'use client';

import { ThemeProvider } from '@/components/theme-provider';
import { Toaster } from '@/components/ui/toaster';
import { AuthProvider } from '@/contexts/auth-context';
import { NutritionProvider } from '@/contexts/nutrition-context';
import { OfflineProvider } from '@/components/providers/offline-provider';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <AuthProvider>
        <NutritionProvider>
          <OfflineProvider>
            {children}
            <Toaster />
          </OfflineProvider>
        </NutritionProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}